import "../lib/common";
import "../lib/common/user_files";
import { DEVELOPMENT } from "../constants";

if (process.env.NODE_ENV === DEVELOPMENT) {
  console.log("--- loaded admin");
}
